import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Banner, BannerVariant } from './Banner';
import Typography from './Typography/Typography';
import { Icon } from 'components/Icon';
import { useGetUnavailableItems } from 'hooks/useGetUnavailableItems';
import { ERROR_EIGHTY_SIXTH } from './EightySixthError.const';

import styles from './EightySixthError.module.scss';

type EightySixthErrorProps = {
  onClick?: () => void;
};

export const EightySixthError: FC<EightySixthErrorProps> = () => {
  const { t } = useTranslation();
  const { hasUnavailableItems, unavailableItemNames } = useGetUnavailableItems();
  const items = unavailableItemNames && unavailableItemNames.join(', ');

  return (
    <>
      {hasUnavailableItems && (
        <Banner
          variant={BannerVariant.ERROR}
          rounded={true}
          className={styles.eightySixthError}
          data-testid={ERROR_EIGHTY_SIXTH.banner}
        >
          <div className={styles.errorIcon}>
            <Icon aria-hidden={true} name={'error'} size={32} />
          </div>
          <div>
            <Typography.Body bold>{t('cart.itemEightySixth.title')}</Typography.Body>
            <Typography.Body dangerouslyUsedClassName={styles.inline}>
              {t('cart.itemEightySixth.description', { items })}
            </Typography.Body>
          </div>
        </Banner>
      )}
    </>
  );
};
